import { createContext } from 'react';
const CurrencyLocaleContext = createContext();
export default CurrencyLocaleContext;
